import { HttpEvent, HttpHandler, HttpHeaderResponse, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FileServicesValidationDto } from "app/shared/fileServiceDto/FileservicesvalidationDto";
import { CommonService } from "app/shared/services/commonService/common.service";
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';

@Injectable()
export class FileservicesvalidationInterceptor implements HttpInterceptor {

    constructor(private commonService: CommonService) { }

    intercept(req: HttpRequest<null>, next: HttpHandler): Observable<HttpEvent<HttpHeaderResponse>> {
        return next.handle(req).pipe(
            map((event: HttpEvent<HttpHeaderResponse>) => {
                if (event instanceof HttpResponse) {
                    if (event.headers.has('Fileservicesvalidation')) {
                        let fileServicesValidation:FileServicesValidationDto = JSON.parse(event.headers.get('Fileservicesvalidation') ?? '');
                        this.commonService.fileServicesValidation.next(fileServicesValidation)
                    }
                }
                return event;
            })
        )
    }
}